<template>
  <div class="beixingDetail">
   
    <div class="himg">
      <div class="detailBox">
        <!--  -->
        <div v-if="bean.oweArea && bean.oweArea.areaVideo">
          <van-popup v-model="showMp4" closeable :style="{ width: '100%' }">
            <video id="video" class="videoContent" controls :autoplay="true" style="width: 100%; height: auto;">
              <source :src="'/' + bean.oweArea.areaVideo" type="video/mp4" />
            </video>
          </van-popup>
        </div>
        <!--  -->
        <div class="himgDiv">
          <div class="img1 img2">
            <div class="openItemimage" style="width: 100%; height: 100%">
              <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
                <van-swipe-item>
                  <div
                    style="background-color: #00000047;
                    padding-top: 1.5rem;
                    width: 100%;
                    height: 10rem;
                    text-align: center;
                    position: absolute;
                    z-index: 1;"
                  >
                    <span @click="showPopup" class="icon iconfont play">&#xe602;</span>
                  </div>
                  <div v-if="bean.oweArea && bean.oweArea.areaVideo" style="position:absolute;z-index:0;">
                    <video id="video1" class="videoContent" style="width: auto; height: 100%;">
                      <source :src="'/' + bean.oweArea.areaVideo" type="video/mp4" />
                    </video>
                    <div id="output" style="position:absolute;left:0;left:0"></div>
                  </div>
                </van-swipe-item>
                <van-swipe-item v-for="(item, index) in bean.gallery" :key="index">
                  <img
                    class="openItemimage__img"
                    style="object-fit: cover"
                    :data-src="item"
                    :src="item"
                    lazy="loaded"
                  />
                </van-swipe-item>
              </van-swipe>
              <img
                class="openItemimage__img"
                style="object-fit: cover;height:auto;"
                lazy="loaded"
                :data-src="bean.gallery[0]"
                :src="bean.gallery[0]"
              />
            </div>
          </div>
          <div class="himgcd">
            <p class="himgcd__name e1">{{ bean.steleName }}</p>

            <div class="himgcd__detail">
              <p class="flex1"><span>园区</span>{{ bean.steleArea }}</p>
              <p class="flex1"><span>穴位</span>{{ bean.steleHole }}</p>
              <p class="flex1"><span>穴位摆放</span>{{ bean.steleSet }}</p>
              <p class="flex1"><span>朝向</span>朝南</p>
              <p class="flex1"><span>葬式</span>{{ bean.steleTheme }}</p>
              <p class="flex1"><span>材质</span>{{ bean.steleType }}</p>
              <p class="flex1"><span>主题风格</span>{{ bean.steleStyle }}</p>
            </div>
          </div>
        </div>
        <div class="ts"></div>
        <div v-if="bean.oweArea && bean.oweArea.areaPhoto" class="detailContent" style="padding: 0.3rem 0.2rem;">
          <img :src="bean.oweArea && bean.oweArea.areaPhoto" style="width:100%;" />
        </div>
        <div class="ts"></div>
        <div class="detailContent">
          <div class="tc tc-1">
            <p class="flex1 marginb20">
              <span class="bxTitle topItem">其他热销碑型</span>
              <a href="/beixing" class="aa">查看更多</a>
            </p>
            <div class="item1">
              <div class="item1__list imgBox">
                <template v-for="(item2, index) in list">
                  <div class="detailclDiv" :key="index">
                    <a href="/bxDetail9">
                      <div class="listImg">
                        <div class="openItemimage" style="width: 100%; height: 100%">
                          <img
                            class="openItemimage__img"
                            style="object-fit: cover"
                            :data-src="item2.firstPhoto"
                            :src="item2.firstPhoto"
                            lazy="loaded"
                          />
                        </div>
                      </div>
                      <p class="title e1">{{ item2.steleName }}</p>
                      <p class="ms e1">
                        {{ joinLabels(item2['labels'], ' | ') }}
                      </p>
                    </a>
                  </div>
                </template>
                <!-- <div class="detailclDiv">
                  <a href="/bxDetail1">
                    <div class="listImg">
                      <div class="openItemimage" style="width: 100%; height: 100%">
                        <img
                          class="openItemimage__img"
                          style="object-fit: cover"
                          data-src="../../../assets/beixing.jpg"
                          src="../../../assets/beixing.jpg"
                          lazy="loaded"
                        />
                      </div>
                    </div>
                    <p class="title e1">草坪葬</p>
                    <p class="ms e1">草坪葬 ｜ 节地环保 ｜ 以现场为准</p></a
                  >
                </div>
                <div class="detailclDiv">
                  <a href="/bxDetail1">
                    <div class="listImg">
                      <div
                        class="openItemimage"
                        style="width: 100%; height: 100%"
                        data-v-2ad5f621=""
                      >
                        <img
                          class="openItemimage__img"
                          style="object-fit: cover"
                          data-src="../../../assets/beixing.jpg"
                          src="../../../assets/beixing.jpg"
                          lazy="loaded"
                        />
                      </div>
                    </div>
                    <p class="title e1">自然石葬</p>
                    <p class="ms e1">立碑艺术墓 ｜ 个性艺术墓 ｜ 以现场为准</p></a
                  >
                </div>
                <div class="detailclDiv">
                  <a href="/bxDetail5"
                    ><div class="listImg">
                      <div class="openItemimage" style="width: 100%; height: 100%">
                        <img
                          class="openItemimage__img"
                          style="object-fit: cover"
                          data-src="../../../assets/beixing.jpg"
                          src="../../../assets/beixing.jpg"
                          lazy="loaded"
                        />
                      </div>
                    </div>
                    <p class="title e1">室内葬</p>
                    <p class="ms e1">立体葬 ｜ 节地环保 ｜ 格位</p>
                  </a>
                </div> -->
              </div>
            </div>
          </div>
          <!-- <div class="ts"></div>
          <div class="tc textCon">
            <p class="bxTitle marginb20">图片展示</p>
            <div class="itemImg">
              <div class="imgList imgBox detailContentimg1">
                <template v-for="(item, index) in bean.gallery">
                  <div v-if="index > 0" class="detailContent1" :key="index">
                    <div class="openItemimage" style="width: 100%; height: 100%">
                      <img
                        @click="imgClick(item)"
                        class="openItemimage__img"
                        style="object-fit: cover"
                        :data-src="item"
                        :src="item"
                        lazy="loaded"
                      />
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div> -->
        </div>
        <div>
          <!---->
          <div>
            <div class="fixedBox fixedDiv flex1">
              <div class="remen">
                <a href="tel:0546-75889977"
                  ><button>
                    官方咨询热线
                    <span>0546-75889977</span>
                  </button>
                </a>
              </div>
              <div class="right" @click="show = true">
                <button>
                  免费看墓专车
                  <span>点击立即预约</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-action-sheet v-model="show" title="预约免费看墓专车">
      <div class="content">
        <van-form ref="form">
          <van-cell title="预约日期" :value="formData.predate" @click="showDate = true" />
          <i class="van-icon van-icon-arrow van-cell__right-icon jiantou"></i>
          <van-calendar v-model="showDate" @confirm="onConfirm" />
          <van-cell-group>
            <van-field
              v-model="formData.mobile"
              label="预约人手机号"
              type="tel"
              placeholder="请输入预约人手机号"
              required
              :rules="telRules"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              v-model="formData.userCount"
              label="同行人数"
              type="digit"
              placeholder="请输入同行人数"
              required
              :rules="tongxingRules"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              v-model="formData.userName"
              label="预约人姓名"
              placeholder="请输入预约人姓名"
              required
              type="text"
              :rules="xingmingRules"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              v-model="formData.idCard"
              type="text"
              label="预约人身份证"
              placeholder="请输入预约人身份证"
              required
              :rules="shenfenzhengRules"
            />
          </van-cell-group>
          <div class="bottom">
            <van-button round block type="info" native-type="submit" @click="submitBought()"
              >提交预约</van-button
            >
          </div>
        </van-form>
      </div>
    </van-action-sheet>
    <van-overlay :show="show1" @click="show1 = false">
      <i class="iconfont" style="color:#fff;">&#xed1a;</i>
      <div class="wrapper" @click.stop>
        <van-image :src="require('../../../assets/beixing.jpg')" />
      </div>
    </van-overlay>
  </div>
</template>

<script>
import bus from '../../../common/bus'
export default {
  name: 'beixingDetail',
  components: {},
  data() {
    return {
      showMp4: false,
      id: 0,
      formData: {
        mobile: '',
        userCount: '',
        userName: '',
        idCard: '',
        predate: '',
      },
      showDate: false,
      // 校验手机号码
      telRules: [
        {
          required: true,

          trigger: 'onBlur',
        },
        {
          // 自定义校验规则
          validator: value => {
            return /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/.test(
              value
            )
          },

          trigger: 'onBlur',
        },
      ],

      tongxingRules: [
        {
          required: true,

          trigger: 'onBlur',
        },
      ],

      xingmingRules: [
        {
          required: true,

          trigger: 'onBlur',
        },
      ],

      shenfenzhengRules: [
        {
          required: true,

          trigger: 'onBlur',
        },
      ],
      show: false,
      imgsrc: '',
      show1: false,
      username: '',
      password: '',
      bean: {
        steleName: '',
        steleArea: '',
        steleHole: '',
        steleSet: '',
        steleTheme: '',
        steleType: '',
        steleStyle: '',
        gallery: [],
        oweArea: '',
      },
      list: [],
      oweArea: '',
    }
  },
  mounted(){
    var visited = this.$getVisited('OweStele_'+this.id)
    if(visited==1){
      this.$plus('OweStele',{id:this.id},['consultCount'])
    }
    //
    setTimeout(() => {
      var video, output;
      var scale = 0.6;
      var initialize = function() {
          output = document.getElementById("output");
          video = document.getElementById("video1");
          video.addEventListener('loadeddata',captureImage);
      };

      var captureImage = function() {
        var canvas = document.createElement("canvas"); 
        canvas.width = video.videoWidth * scale;
        canvas.height = video.videoHeight * scale;
        canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height); 
        var img = document.createElement("img"); 
        img.src = canvas.toDataURL("image/png"); 
        output.appendChild(img); 
        };

        initialize();
    }, 10000)
    
  },
  created() {
    this.id = this.$route.params.id
    bus.$emit('path', 'beixing')
    var that = this
    // ['id', 'oweArea.areaName', 'oweArea.areaPhoto', 'oweArea.areaVideo', 'steleName', 'labels', 'steleArea', 'steleHole', 'steleSet', 'steleTheme', 'steleType', 'steleStyle', 'tombCount', 'consultCount', 'orderNum'],
    this.$queryOne('/api/stele/querySteleOne', { id: this.id, max: 4 },
      ['id', 'oweArea.areaName', 'oweArea.areaPhoto', 'oweArea.areaVideo', 'steleName', 'labels', 'steleArea', 'steleHole', 'steleSet', 'steleTheme', 'steleType', 'steleStyle', 'tombCount', 'consultCount', 'orderNum'], 
      function (res) {
        //console.log(res)
        that.$fill(that.bean, res.data)
        that.$fill(that.list, res.list)
    })
  },
  methods: {
    showPopup() {
      this.showMp4 = true
    },
    onSubmit(values) {
      console.log('submit', values)
    },
    submitBought() {
      this.$submit('MsgBought', this.formData, function(res) {
        if (res['code'] === 1) {
          alert('成功')
        }
      })
    },
    joinLabels(labels) {
      if (labels) {
        labels.join(labels, ' | ')
      }
    },
    imgClick(img) {
      this.show1 = true
      this.imgsrc = img
    },
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    onConfirm(date) {
      this.showDate = false
      this.formData.predate = this.formatDate(date)
    },
  },
  watch: {
    formData: {
      handler() {
        if (
          /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/.test(
            this.formData.mobile
          ) &&
          this.formData.userName &&
          this.formData.idCard &&
          this.formData.userCount &&
          this.formData.date
        ) {
          this.saveFlag = true
        } else {
          this.saveFlag = false
        }
      },
      deep: true,
    },
  },
}
</script>

<style>
.beixingDetail .van-overlay {
  z-index: 999;
  display: flex;

  align-items: center;
  background:#000;
}
.van-swipe__indicators{
  bottom: 0.5rem;
}
.beixingDetail .van-overlay i {
  position: absolute;
  top: 1rem;
  right: 0.5rem;
  color: #fff;
  font-size: 1rem;
}
.beixingDetail .himg {
}
.beixingDetail .himg .img {
  width: 100%;
  height: 100%;

  position: relative;
  display: inline-block;
}
.beixingDetail .himg .img img {
  object-fit: cover;

  display: block;
  width: 100%;
  height: 100%;
}
.beixingDetail .detailBox {
}

.beixingDetail .openItemimage__error,
.beixingDetail .openItemimage__img,
.beixingDetail .openItemimage__loading {
  display: block;
  width: 100%;
  height: 100%;
}

.beixingDetail .openItemimage {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 100%;
}
.beixingDetail .detailBox .himgDiv .img2 {
  height: 6.5rem;
}
.beixingDetail .img1 {
  height: 3.73rem;
}

.beixingDetail .detailBox .himgDiv .himgcd {
  padding: 0.4rem;

  position: relative;
  background: #fff;
}
.beixingDetail .detailBox .himgDiv .himgcd:before {
  content: '';
  width: 100%;
  height: 0.27rem;
  border-radius: 0.27rem 0.27rem 0 0;
  background: #fff;
  position: absolute;
  top: -0.24rem;
  left: 0;
  right: 0;
  z-index: 2;
}
.beixingDetail .detailBox .himgDiv .himgcd__name {
  font-size: 0.53rem;
  font-weight: 500;
  color: #333;
  line-height: 0.75rem;
  margin-bottom: 0.13333rem;
}
.beixingDetail .e1 {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.beixingDetail .detailBox .himgDiv .himgTitle {
  font-size: 0.37333rem;
  color: #666;
  line-height: 0.53rem;
  margin-bottom: 0.27rem;
}
.beixingDetail .e2,
.beixingDetail .e3 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.beixingDetail .e2 {
  -webkit-line-clamp: 2;
}
.beixingDetail .detailBox .himgDiv .himgc1 {
  font-size: 0.37333rem;
  color: #666;
  line-height: 0.53rem;
  padding-left: 0.4rem;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAwCAMAAABUpcipAAABU1BMVEUAAAD//////3//qqr/zJn/tm3fv3/ms4DouXTqqmrrsXbhtGnjqnHnqm3psW/fqmrerWvfp2jgqmziqG3jrGfgqGriqGjjrGngrGjgqGvhqmnirGzhqWjgqmnhqGjfqGffqWngqGreqGneqWjfp2rfqWffqGngqWjeqWjep2nfqWngqGfeqGnfqGffqGngqGnep2fgqGjfqGffp2jfqGngqWjgp2feqWjfp2nfqWffp2jfqGjfqGfeqGjeqGnfp2jfqGjfp2jfqGngqGjfqGjfp2jfp2jfqGffqGjeqGfep2ffqGjfp2ffqGfep2jeqGjeqGffqGffp2jeqGjep2ffqGffqGjep2jeqGjfp2ffqGjfp2feqGfep2jfp2jfqGffp2jfp2ffqGjep2fep2jeqGjfqGfep2jeqGjfp2ffqGffqGjeqGjfqGffp2jfqGfep2e4n/BZAAAAcHRSTlMAAQIDBQcICgsMDRESFRcYHyAhIyUpLC4xMjM0O0tMT1BSVVZXWWFiZWZoam1vcHJ0e36AgYKDhYaIjpiZm5ydn6ChoqWprq+wsrS2t7m6u7y+wMLDzdDR09TV19na3d7l5ufo6erv8fP09fb7/P3+pENUwwAAAZRJREFUGBmNwWkjVFEABuB3RsWEytaCSI6lUtHUHQehkm1sbbfGpKjBoDPe//8pwzjLnbt4Hrg6Xn7Y3D4o+fnZkVZEuu0VaFS+vmhEmJtvjhiwN9qAOoP7DFHsgSvlMdzJEGyNS4yUg5FaZIwJaB7jnD5CzWPGK9/FucxfJviMc1km6sOZW2U6itOvvPd7dBTSALK0rd9HVerhD9r6APg0KuO4dP0dLbNAGy3jsHykUUrjOY0N2Jp2afRijkY3HE9pPMMatZ9wtfyj5uE7tbcI8KnNYZ/aawTkqeWxS20SAVvUVvCN2gICdqjNYJVaKQ1HO40sZmj0w5GjMYohGsUbsNw5ptGJZkVjIQUt49PYAfCFlsUMatp8WqYAPKHtz1grznRMntD2AMC133RUCuufftG1jKphJjm9h6oGnwnmcaHzkLG2m1AzwDjlLmgeo6kBWCSjKAGHZDglECAZRgnUkaynBEJIBimBUJIuJRBB0qYEIkkaSiCG5CUlEEvyghJIIFmlBBJJkkrgCiSVwJXkBOr9B4jB3Tv8z+zRAAAAAElFTkSuQmCC)
    no-repeat 0/0.27rem 0.32rem;
  margin-bottom: 0.4rem;
}
.beixingDetail .e1 {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.beixingDetail .detailBox .himgDiv .himgcd__detail {
  padding-top: 0.4rem;
  border-top: 0.027rem solid #dfdfdf;
}
.beixingDetail .detailBox .himgDiv .himgcd__detail p {
  font-size: 0.37333rem;
  color: #666;
  line-height: 0.53rem;
  margin-bottom: 0.27rem;
}
.beixingDetail .flex1,
.beixingDetail .flex2 {
  justify-content: space-between;
}
.beixingDetail .flex1,
.beixingDetail .flex3 {
  display: flex;
  align-items: center;
}
.beixingDetail .ts {
  width: 100%;
  height: 0.13333rem;
  background: #f6f6f6;
}

.detailBox .detailContent .tc {
  padding: 0.67rem 0.4rem;
  background: #fff;
}
.beixingDetail .marginb20 {
  margin-bottom: 0.53rem;
}

.beixingDetail .bxTitle.topItem {
  padding-left: 0;
  position: relative;
}
.beixingDetail .bxTitle {
  font-size: 0.53rem;
  font-weight: 500;
  color: #dea767;
  line-height: 0.75rem;
}
.beixingDetail .detailBox .detailContent .item1__list {
  display: flex;
}
.beixingDetail .imgBox {
  display: flex;
  flex-wrap: wrap;
}

.beixingDetail .detailBox .detailContent .detailclDiv {
  width: 4.265rem;
  margin-right: 0.67rem;
  margin-top: 0.53rem;
}
.beixingDetail .detailBox .detailContent .detailclDiv:nth-child(2n) {
  margin-right: 0;
}
.beixingDetail .detailBox .detailContent .detailclDiv:first-child,
.beixingDetail .detailBox .detailContent .detailclDiv:nth-child(2) {
  margin-top: 0;
}

.beixingDetail .detailBox .detailContent .tc {
  padding: 0.67rem 0.4rem;
}
.beixingDetail .bxTitle {
  font-size: 0.53rem;
  font-weight: 500;
  color: #dea767;
  line-height: 0.75rem;
}
.beixingDetail .marginb20 {
  margin-bottom: 0.53rem;
}
.beixingDetail .detailBox .detailContent .detailContentimg1 {
  height: 2.93rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.beixingDetail .imgBox {
  display: flex;
  flex-wrap: wrap;
}
.beixingDetail .detailBox .detailContent .detailContent1 {
  width: 2.93rem;
  height: 2.93rem;
  border-radius: 0.05333rem;
  overflow: hidden;
  margin-right: 0.2rem;
  margin-top: 0.27rem;
}
.beixingDetail .detailBox .detailContent .detailContentimg {
  font-size: 0.37333rem;
  color: #999;
  margin-top: 0.4rem;
}
.beixingDetail .aa {
  font-size: 0.32rem;
  color: #dea767;
  line-height: 0.45333rem;
}
.beixingDetail .detailBox .detailContent .detailclDiv .ms {
  font-size: 0.32rem;
  color: #666;
  line-height: 0.53rem;
}
.beixingDetail .detailBox .detailContent .detailclDiv .title {
  font-size: 0.42667rem;
  font-weight: 500;
  color: #333;
  line-height: 0.61333rem;
  margin-bottom: 0.05333rem;
}
.beixingDetail .fixedBox button {
  width: 4rem;
  height: 1.17333rem;
  border-radius: 0.58667rem;
  overflow: hidden;
}
.beixingDetail .remen a button {
  border: 0.027rem solid #dea767;
  color: #666;
  font-size: 0.32rem;
  background: #fff;
  width: 4rem;
  height: 1.17333rem;
  border-radius: 0.58667rem;
  overflow: hidden;
}
.beixingDetail button {
  border: none;
  outline: none;
}
.beixingDetail .fixedBox .right button {
  color: #333;
  font-size: 0.32rem;
  background: #dea767;
}
.beixingDetail .fixedBox button {
  width: 4rem;
  height: 1.17333rem;
  border-radius: 0.58667rem;
  overflow: hidden;
}
.beixingDetail .fixedDiv {
  height: 1.6rem;
  background: #fff;
  box-shadow: 0 -0.027rem 0.05333rem 0 hsl(0deg 0% 89% / 50%);
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  padding: 0.21333rem 0.4rem;
}
.beixingDetail .fixedDiv .right button span {
  font-size: 0.37333rem;
  font-weight: 500;
  color: #333;
}
.beixingDetail .fixedDiv button span {
  display: block;
}
.beixingDetail .van-field__control {
  text-align: right;
}
.beixingDetail .van-cell__value span {
  padding-right: 1.5rem;
}
.beixingDetail .bottom {
  margin: 4rem auto;
  width: 80%;
  height: 1rem;
  line-height: 1rem;
  font-size: 0.32rem;
  background-color: #fff;
  display: flex;
  justify-content: flex-end;
}

.beixingDetail .bottom van-button {
  position: relative;
  width: 100%;

  font-size: 0.32rem;
  text-align: center;
  background-color: #15a892;
  color: #fff;
  border-radius: 2500px;
}

.beixingDetail .van-cell {
  height: 1.2rem;
  line-height: 1.2rem;
}
.beixingDetail .van-cell-group {
  height: 1.2rem;
  line-height: 1.2rem;
}

.beixingDetail .serviceTitle {
  padding: 1.3rem 0;
  line-height: 4rem;
  height: 4rem;
  font-size: 1.8rem;
  width: 100%;
  padding: 10px 16px;
  margin: 0 auto;
}
.beixingDetail .jiantou {
  position: absolute;
  right: 0.3rem;
  top: 1.7rem;
}
.beixingDetail .play {
  display: block;
  font-size: 75px;
  color: #fff;
  animation: mymove 3s infinite;
  position: relative;
  animation: mymove 3s infinite;
  -webkit-animation: mymove 3s infinite; /*Safari and Chrome*/
  animation-direction: alternate; /*轮流反向播放动画。*/
  animation-timing-function: ease-in-out; /*动画的速度曲线*/
  /* Safari 和 Chrome */
  -webkit-animation: mymove 3s infinite;
  -webkit-animation-direction: alternate; /*轮流反向播放动画。*/
  -webkit-animation-timing-function: ease-in-out; /*动画的速度曲线*/

}
@keyframes mymove {
  0% {
    transform: scale(1); /*开始为原始大小*/
  }
  25% {
    transform: scale(1.1); /*放大1.1倍*/
  }
  50% {
    transform: scale(1);
  }
  75% {
    transform: scale(1.1);
  }
}

/* .beixingDetail .submitBtn {
  min-width: 4rem;
  background-color: #dea767;
  border-color: #dea767;

  border-radius: 26.64rem;

  display: block;
  width: 100%;

  padding: 0 0.4rem;
  font-size: 0.37333rem;

  color: #323233;
  background-color: #fff;
  border: 0.027rem solid #ebedf0;

  position: relative;
  display: inline-block;
  box-sizing: border-box;
  height: 1.17333rem;
  margin: 0;
  padding: 0;
  font-size: 0.42667rem;
  line-height: 1.2;
  text-align: center;
  border-radius: 0.05333rem;
  cursor: pointer;
  -webkit-transition: opacity 0.2s;
  transition: opacity 0.2s;
  -webkit-appearance: none;

  border: none;
  outline: none;
} */
/* .beixingDetail .submitBtnCon {
  min-width: 4rem;
  background-color: #dea767;
  border-color: #dea767;
} */
</style>
